import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationFreeChargeRequest } from '@dto/ocpp/chargingStationFreeChargeRequest';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { HttpState } from 'src/app/types/HttpState';


@Component({
  selector: 'app-enable-free-charge-dialog-content',
  templateUrl: './enable-free-charge-dialog-content.component.html',
  styleUrls: ['./enable-free-charge-dialog-content.component.css']
})
export class EnableFreeChargeDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EnableFreeChargeDialogContentComponent';

  @Input() private chargingStation: ChargingStation;
  @Input() private currentStatus: boolean;

  public isResetPressed: boolean = false;
  public state: HttpState = '';

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationService: ChargingStationsService,
    injector: Injector) {
    super(activeModal, injector);
  }

  onConfirmClick() {
    this.isResetPressed = true;
    this.state = 'loading';

    var freeChargeRequest: ChargingStationFreeChargeRequest = {
      freeCharging: true
    }

    if (this.currentStatus == true) {
      freeChargeRequest.freeCharging = false;
    }

    this.chargingStationService.configureFreeCharge(this.chargingStation.id, freeChargeRequest).subscribe(result => {
      if (result.status == true) {
        this.state = 'success';
      }
      else {
        this.state = 'failure';
      }
    }, error => {
        this.state = 'failure';
    });
    return super.activeModal.close();
  }

  onCancelClick() {
    this.activeModal.close({ state: 'failure' });
  }

  onOkClick() {
    this.activeModal.close({ state: this.state });
  }

}
